import { render, staticRenderFns } from "./vaccine.vue?vue&type=template&id=16d52334&scoped=true"
import script from "./vaccine.vue?vue&type=script&lang=js"
export * from "./vaccine.vue?vue&type=script&lang=js"
import style0 from "./vaccine.vue?vue&type=style&index=0&id=16d52334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d52334",
  null
  
)

export default component.exports